import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Calculater from '../../components/calculater/calculater';
import './index.css';
import { motion, AnimatePresence } from 'framer-motion';

export default function Home() {
  const { docRefAvaliacao } = useParams();

  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1200); // pode aumentar um pouco o tempo se quiser mais destaque

    return () => clearTimeout(timer);
  }, []);

  const handleEnter = () => {
    window.location.href = "https://app.itroca.com.br/login";
  };

  const handleRegister = () => {
    window.location.href = "https://app.itroca.com.br/cadastrotipousuario";
  };

  return (
    <AnimatePresence mode="wait">
      {showSplash ? (
        <motion.div
          key="splash"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            backgroundColor: '#ffffff',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <img
            src="https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/i-troca-qkfavh/assets/yfki2lz2mcww/iTroca_-_PRETO_(1).png"
            alt="iTroca logo"
            style={{ width: '820px  ', objectFit: 'contain' }} // AUMENTADA
          />
        </motion.div>
      ) : (
        <motion.div
          key="home"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="home-container"
        >
          <div className="home-top">
            <div className="welcome">Bem-vindo(a)!</div>
            <div className="line"></div>
            <div className="home-buttons">
              <button className="btn-enter" onClick={handleEnter}>Entrar</button>
              <button className="btn-register" onClick={handleRegister}>Criar conta</button>
            </div>
          </div>

          <div className="home-calculator-container">
            <div className="home-calculator-content">
            <Calculater docRefAvaliacao={docRefAvaliacao} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
